import type { ReactNode } from 'react';

export type ProviderTile = {
  id: string;
  label: string;
  trigger: ReactNode;
};

export type ProviderTileRowProps = {
  tiles: ProviderTile[];
};

export const ProviderTileRow = ({ tiles }: ProviderTileRowProps) => (
  <div className="capture-provider-tiles">
    {tiles.map((tile) => (
      <div key={tile.id} className="capture-provider-tile">
        {tile.trigger}
        <div className="capture-provider-tile-label">{tile.label}</div>
      </div>
    ))}
  </div>
);
